<template>
  <div class="About">
    <div class="container">
        <div class="logo">
            <img src="@/assets/PC/about/logo.png" alt="">
        </div>
        <div class="title1">AVEVA 剑维软件</div>
        <p>
            <span>AVEVA Group plc（LSE: AVV） ，</span>是一家专注于工业软件研发的跨国企业，总部位于英国剑桥。该公司通过整合数字孪生技术和工业智能平台，为能源、化工、电力、造船、基础设施等工业领域提供覆盖规划、设计、建造、运营等全生命周期的解决方案。其产品体系涵盖工程设计、材料管理、生产监控、资产维护等工业流程，支持企业在工厂建设与生产运营环节的数字化转型。
        </p>
        <div class="intro-item">
            <b>公司名称：</b>剑维软件
        </div>
        <div class="intro-item">
            <b>外文名：</b>AVEVA Group plc
        </div>
        <div class="intro-item">
            <b>成立时间：</b>1967 年
        </div>
        <div class="intro-item">
            <b>总部地点：</b>英国剑桥
        </div>
        <div class="intro-item">
            <b>经营范围：</b>软件和编程
        </div>
        <div class="intro-item">
            <b>曾用名称：</b>CADCentre
        </div>
        <div class="title2">1. 简介</div>
        <p>AVEVA 剑维软件起源于 1967 年剑桥大学工程设计 CAD Centre，最初专注于计算机辅助设计（CAD）。上世纪 70 年代末，公司转向商业化运作，推出全球首个三维工厂设计系统 PDMS。1987 年，Dennis Morin 发布基于 Windows 的 InTouch HMI 人机界面，提升工厂操作的直观性。2018 年通过反向并购施耐德电气软件业务部门，整合工业运营类软件产品；2021 年完成对 PI System 的收购，强化工业数据管理能力。该公司在工程设计、工厂运维等领域提供专业软件解决方案，业务覆盖能源、化工、造船等工业领域，截至 2022 年运营数据显示，其全球设有 10 个技术研发中心，员工规模逾 7000 人。</p>
        <div class="img-three">
            <img src="@/assets/PC/about/img1.png" alt="">
            <img src="@/assets/PC/about/img2.png" alt="">
            <img src="@/assets/PC/about/img3.png" alt="">
        </div>
        <p class="tip">AVEVA 剑维软件品牌视频（截图）</p>
        <div class="title2">2. 进入中国市场</div>
        <p>
            1996 年剑维软件进入中国，并分别于北京、上海、广州设有办公室。截至 2023 年 9 月，其在华技术团队规模逾 90 人，服务国内工业客户群体，与本土企业建立技术合作关系。该公司通过客户体验中心等载体，开展工业软件平台的技术展示与合作交流。
        </p>
        <p>
            2023 年 9 月 6 日，AVEVA 剑维软件中国客户体验中心（Customer Experience Center，CEC）在北京正式启幕，设立的体验中心（CEC）主要展示工业数字化解决方案，包含数据可视化系统及虚拟现实技术应用演示模块。
        </p>
        <div class="title2">3. 发展历程</div>
        <div class="li"><span></span>1967 年发源于剑桥大学 CAD 中心的一个用三维设计工具进行工厂设计的项目。到了 20 世纪 70 年代末、80 年代初，由于英国经济低迷，政府停止了对此项目的支持。</div>
        <div class="li"><span></span>1996 年，AVEVA 在伦敦上市，并于同年正式进入中国市场。</div>
        <div class="li"><span></span>2001 年正式更名为 AVEVA Group。</div>
        <div class="li"><span></span>2004 年 5 月，AVEVA 剑维软件集团收购了造船解决方案公司 Tribon Solutions AB，AVEVA 于 2008 年推出划时代的 AVEVA Marine 智能工程平台。</div>
        <div class="li"><span></span>2013 年，AVEVA E3D Design 作为 PDMS 的升级产品，作为新一代工程设计产品被正式推出。</div>
        <div class="li"><span></span>2018 年 3 月，AVEVA 剑维软件和施耐德电气软件业务部门正式合并。</div>
        <div class="li"><span></span>2021 年 3 月，AVEVA 剑维软件宣布正式完成对 OSIsoft 的收购，PI System 作为一款广泛应用于电力、石油、炼化、造纸、制药等行业的工业级实时数据库正式加入 “剑维宇宙”，并推出“精智绩效” (Performance Intelligence)。</div>
        <div class="li"><span></span>2023 年 1 月，AVEVA 剑维软件宣布施耐德电气完成对其全资收购。</div>
        <div class="title2">4. 市场覆盖</div>
        <div class="table">
            <div class="table-header">
                <div>行业</div><div>可以应用的细分领域</div>
            </div>
            <div class="table-body">
                <div>石油、天然气和能源</div><div>上游；油田服务；液化天然气液化/再气化/运输；天然气加工/分馏存储；集输管线；液体与气体输送管道；管道和计量；管道基础设施；下游；绿氢；绿氨；其他新能源等</div>
            </div>
            <div class="table-body">
                <div>EPC 工程、采购和施工</div><div>EPC 工程、采购和施工</div>
            </div>
            <div class="table-body">
                <div>化工</div><div>石化产品；大宗化学品；聚合物和纤维；专用化学品；肥料和农用化学品等</div>
            </div>
            <div class="table-body">
                <div>消费品</div><div>农业；食品；饮料；家庭和个人护理等</div>
            </div>
            <div class="table-body">
                <div>生命科学</div><div>小分子；大分子；个性化医疗；CMO/CDMO；仿制药制造商；早期基础/应用研究等</div>
            </div>
            <div class="table-body">
                <div>离散制造</div><div>汽车；航空航天与国防；消费品和耐用品；电子消费品；医疗设备；半导体；机械设备制造商等</div>
            </div>
            <div class="table-body">
                <div>基础设施</div><div>设施和建筑；智慧城市；水及废水处理；数据中心等</div>
            </div>
            <div class="table-body">
                <div>矿业、矿产和金属</div><div>矿产；金属；矿物等</div>
            </div>
            <div class="table-body">
                <div>纸浆、造纸和林产品</div><div>纸浆和造纸；生物炼制厂；能量颗粒；木质建筑材料等</div>
            </div>
            <div class="table-body">
                <div>海事</div><div>海洋工程与执行；造船厂运营；船舶运营等</div>
            </div>
            <div class="table-body">
                <div>电力与公用事业</div><div>化石能源；余热发电；核电；水电；风电；太阳能；地热；生物质；输配电等</div>
            </div>
            <div class="table-body">
                <div>交通运输</div><div>港口；航天；铁路交通；道路等</div>
            </div>
            <div class="table-body">
                <div>智能出行</div><div>电动汽车；电动汽车电池；充电基础设施等</div>
            </div>
        </div>
        <div class="title2">5. 解决方案</div>
        <div class="img-one">
            <img src="@/assets/PC/about/img4.png" alt="">
        </div>
        <div class="title3">AVEVA 构建工程信息和运营信息的数字孪生</div>
        <p>AVEVA 剑维软件通过将工程信息与运营信息深度融合，构建贯穿工程设计、建设、运营及优化等全生命周期的数字孪生体系。工程信息平台侧重于工程项目的精细化管理，在工程阶段整合结构化与非结构化数据，实现数据的标准化存储、关联和索引，并确保信息的完整性和可追溯性，使工程数据能够顺畅交接至运营阶段。运营信息平台则致力于企业整体运营效率的提升，全面采集生产运行过程中的实时数据，并将其与工程数据深度融合。 </p>
        <p>基于这一数字化管理体系，AVEVA 剑维软件提供对象化、集成化、可视化的数据管理能力，打破信息孤岛，实现跨系统、跨部门的数据协同。数据的互联互通不仅提升了设备资产管理水平，还支撑了生产运行的智能化和透明化，使企业能够基于高质量数据进行精准决策。</p>
        <div class="title2">6. 主要产品和方案</div>
        <div class="title3">AVEVA 工艺仿真</div>
        <p>AVEVA的流程模拟系列产品源自于 SIMSCI 品牌，从上世纪 60 年代发展至今，被广泛应用于油气、炼油、石化、化工行业的研发、设计与优化，在国内外有着广大的用户基础。</p>
        <p>
            <b>AVEVA PRO/II Simulation（PRO/II）</b><br>
            PRO/II 是一款历史悠久的通用化工稳态流程模拟软件，最早起源于 1967 年 SimSci 公司 开发的世界上第一个炼油蒸馏模拟器 SP05，受到全球炼化行业的认可。同时 PRO/II 也是最早进入中国市场的流程模拟软件，自 1980 年代进入中国以来，在研究机构、设计院、 炼化企业被广泛使用至今，已成为炼油、石化、化工等行业必不可少的计算工具软件。<br>
            PRO/II 基于行业领先的热力学方法与物性数据，进行严格的质量与能量平衡计算。可应用于工艺研发、工厂设计、方案比较、装置改造、装置标定、开车指导、 可行性研究、脱瓶颈分析等领域。
        </p>
        <div class="img-one">
            <img src="@/assets/PC/about/img5.png" alt="">
        </div>
        <p>
            <b>AVEVA Dynamic Simulation（DYNSIM）</b><br>
            DYNSIM 是 AVEVA 于 2002 年推出的专业动态工艺仿真平台，基于严格的机理模型和热力学数据，计算化工过程中的工艺参数由于扰动和操作而随时间的变化与响应。严格动态机理模型就像一个虚拟的工厂，能表征装置在工艺侧的行为，可用于石油、化工、电力行业的工程研究、控制系统校核、操作员仿真培训（OTS）、工厂运营操作指导等。<br>
            AVEVA 基于 DYNSIM 在全球交付了 1000+ 套 OTS 系统，涵盖油气、炼油、石化、聚合物、煤化工、电力等行业，还能够与 AVEVA 的虚拟现实技术相结合，打造出从内核到外观都逼真的虚拟工厂。另外，在设计阶段，DYNSIM 越来越多的被各大设计院用于泄放分析、压缩机启停研究、控制逻辑验证等，成为高效的辅助设计手段。
        </p>
        <div class="img-one">
            <img src="@/assets/PC/about/img6.png" alt="">
        </div>
        <p>
            <b>AVEVA Process Simulation（APS）</b><br>
            APS 是 AVEVA 公司全新开发的新一代的流程模拟平台，继承了 SIMSCI 丰富的组分库与热力学方法，同时满足稳态模拟、动态模拟、水力学计算、工艺优化、经济核算、碳排放核算等多种计算目的，可广泛用于石化 & 化工工艺设计、工艺场景动态分析、公用工程（蒸汽、冷却水等）管网设计与核算、安全泄放系统（火炬）设计与核算、新能源与绿氢绿化工工艺模拟等。架构开放，可通过数学语言便捷自定义模型；支持运营，可集成 PI 实时数据库用于化工装置生产指导；兼容新技术，可嵌入 AI 模型进行混合模拟。
        </p>
        <div class="img-one">
            <img src="@/assets/PC/about/img7.png" alt="">
        </div>
        <div class="img-one">
            <img src="@/assets/PC/about/img8.png" alt="">
        </div>
        <div class="title3">AVEVA 一体化工程设计</div>
        <p>AVEVA E3D Design 三维协同布置设计软件可以支持无冲突的多专业三维设计，并可快速生成准确的工程图和报告，以降低新建和已建项目的成本和商业风险，同时缩短工期。使用 AVEVA E3D Design 可以依据行业规范和项目要求实现全专业（工艺、管道、建筑、结构、自控、给排水、暖通、电气、支吊架等）三维设计、碰撞检查以及设计状态管理，输出无差错的图纸和材料表为 EPC 项目中使用。软件广泛应用于石化、化工、电力、造船、海上平台、制药、造纸、环保等行业。同时 E3D 提供了丰富的外部接口支持导入各类模型格式用于设计参考，并且提供了无缝集成激光点云模型的功能。</p>
        <p>在 E3D 基础上，企业可以拓展应用 AVEVA Unified Engineering 整合 FEED 设计、系统设计、布置设计的各专业数据，包括对象清单、P&ID 系统设计、电气仪表系统设计、各专业三维设计，基于统一平台为各专业打造标准驱动、无缝协同的设计环境，并且直接生成各专业所需的交付物，从而实现不同专业、不同项目团队之间的高效协同，以提高工程项目的设计质量和设计效率，同时支持生成高质量的数字化交付成果。</p>
        <p>AVEVA Unified Engineering 支持与上游工艺模拟计算数据集成，与下游材料管理和数字化交付的数据贯通。</p>
        <div class="img-three">
            <img src="@/assets/PC/about/img91.png" alt="">
            <img src="@/assets/PC/about/img92.png" alt="">
            <img src="@/assets/PC/about/img93.png" alt="">
        </div>
        <div class="title3">AVEVA ERM 材料与施工管理</div>
        <p>AVEVA ERM 解决方案通过一体化的材料与施工管理平台，优化工程项目的全流程管控。相比传统分散管理模式，AVEVA ERM 将材料管理、施工规划、资源调配与工程数据深度融合，实现数据互通，提升工程执行效率。</p>
        <p>在材料管理方面，AVEVA ERM 贯穿预算、采购、库存到发货的全生命周期，确保材料在正确的时间、地点精准交付，减少浪费和成本超支。施工管理则依托精细化计划与资源协调，优化任务调度，减少返工与工期延误，同时提供实时数据支持，提升决策精准度。</p>
        <p>通过云部署与系统集成，AVEVA ERM 可无缝对接企业现有 IT 架构，实现多方协作和远程访问。结合 AVEVA 剑维软件其他解决方案，企业能够建立统一的工程管理体系，提升项目透明度，降低成本，实现高效、可控的项目执行。</p>
        <div class="img-one">
            <img src="@/assets/PC/about/img10.png" alt="">
        </div>
        <div class="title3">AVEVA 数字化交付</div>
        <p>AVEVA 数字化交付通过资产信息管理 <span>（AIM）</span> 平台，构建工程与运营数据的统一环境，实现全生命周期的高效数据管理。传统项目中，工程数据分散在不同系统和团队中，难以整合，而 AVEVA AIM 通过智能数据关联和可视化，将设计、施工、运营信息无缝衔接，确保数据的一致性和可追溯性。 </p>
        <p>在工程建设阶段，AVEVA AIM 通过数据标准化和治理，提高交付质量，加快工程文档审核，减少信息孤岛，确保项目按期推进。进入运营阶段，系统提供快速数据检索、文档管理和三维可视化，使运营团队能够高效访问设备信息。支持云和本地部署的灵活部署模式，AVEVA AIM 还能支持远程协作，确保企业在任何地点都能安全访问关键信息，进一步提升数字化交付的透明度和可靠性。</p>
        <div class="title3">AVEVA InTouch HMI 解决方案</div>
        <p>AVEVA InTouch HMI 是一款世界领先的 HMI <span>（人机界面）</span> 软件，广泛应用于工业控制与监测。该方案通过直观的可视化界面，帮助企业优化运营管理，提升生产效率。 </p>
        <p>在应用扩展方面，AVEVA InTouch HMI 支持网页端访问，用户可通过 HTML5 浏览器实现远程监控与操作，无需额外安装软件。此外，系统支持与 OPC UA、SQL 等多种标准接口对接，实现数据互联互通，助力企业构建智能化工厂。通过与云技术的深度集成，AVEVA InTouch HMI 进一步提升工程协作与数据共享能力，使企业能够在任意设备上随时随地安全访问生产数据，实现高效、透明的运营管理。</p>
        <div class="img-one">
            <img src="@/assets/PC/about/img11.png" alt="">
        </div>
        <div class="title3">AVEVA System Platform 用于监控、HMI、SCADA 和 IIoT 的实时操作控制平台</div>
        <p>AVEVA 系统平台是世界上唯一的响应式、可扩展的解决方案，适用于监控、SCADA、HMI 和 IIoT 应用，将流程与企业整合在一起。系统平台提供了一个基于标准的协作基础，可以整合所有人员、流程和资产，以实现持续的运营改进和实时决策支持。</p>
        <p>通过 AVEVA 系统平台，在整个企业范围内实现跨流程、团队和工厂的标准合规性。其开放架构为不同业务系统的实时流程、警报、事件和归档历史数据添加了通用上下文信息，并创建了一个单一的通用信息模型，让系统设计和维护更加高效、灵活和安全。</p>
        <p>System Platform 非常开放，能够与无数的硬件控制和测量设备以及制造系统相连接。它可以充分利用工程技术，减轻维护负担并提高可扩展性，同时利用虚拟化和云计算等最新的 IT 计算技术。</p>
        <div class="title3">Work Tasks 流程管理</div>
        <p>Work Tasks 一种先进的业务流程和工业工作流管理软件，用于管理运营活动，包括组织内部或外部的人员和系统。软件提供了一个数字框架来建模、执行、监控和分析工作流程。包括丰富的功能，可以赋能工人，以及连接工厂系统和设备、业务应用程序、第三方系统和本地或云端的各种数据源。</p>
        <div class="title3">MES 制造执行系统</div>
        <p>AVEVA MES 提供了一整套软件功能，用于管理整个工业制造工厂的人员、生产和质量活动，跟踪和追溯库存和材料，促进业务流程的持续改进、生成即时可见的数据分析和报告。通过工单管理、物料清单、规格、数据收集和追溯性（跟踪/追踪/族谱）等，增强了库存管理、认证、人工和生产步骤等方面的能力。其模型驱动的 MES 方法可以实现操作流程、设备和活动的标准化，从而更快地提高生产率、质量，并在多站点运营中节约成本，轻松实现从边缘到企业的扩展，并缩短卓越运营计划的价值实现时间。</p>
        <div class="title3">Production Management 生产管理</div>
        <p>现成的软件配置型应用程序，专为 MMM 行业设计的领先的运营管理软件，旨在帮助优化生产、流程、绩效和能源使用。提供对工厂和业务信息的近乎实时的访问，提高运营效率，降低能耗。将收集的相关数据转化为易于理解的实时智能报告，用于生产力分析。可以解决绩效问题，如流程瓶颈和生产停机时间，以及计算 KPI 和实际生产成本等。</p>
        <div class="title3">Batch Management 批次管理</div>
        <p>Batch Management 是一款独立于控制系统的批次管理软件。其完全符合 ISA S88.01 行业标准，可以提供配方管理、批次 执行、设备分配、物料谱系、电子批记录、严格的安全措施和基于 Web 的报告等多种功能。可用于多产品和多流批次操作，包括配方管理、物料管理、并发批次计划和执行以及服务器冗余。能高效地管理批次执行，确保质量可重复，并提高效率，同时将每个批次作为单独的流程进行优化。</p>
        <div class="title3">OMI - 运营管理界面</div>
        <p>System Platform 内嵌了全新架构的交互界面系统。</p>
        <p>通过情境感知和数据驱动可视化来推动行动。OMI 利用响应式框架从根本上改进传统 HMI 体验。基于 AVEVA System Platform 的工程技术，运营管理界面提供了独立于分辨率的导航功能，为系统部署提供了灵活性。</p>
        <div class="img-two">
            <img src="@/assets/PC/about/img121.png" alt="">
            <img src="@/assets/PC/about/img122.png" alt="">
        </div>
        <div class="title3">AVEVA Predictive Analytics 预测分析</div>
        <p>AVEVA™ Predictive Analytics 预测分析使工业公司能够在无需代码的环境中利用 AI 技术避免代价高昂的计划外停机。AVEVA Predictive Analytics 在提供基于人工智能的大规模预测分析方面拥有超过 15 年的经验，可帮助工业用户在故障发生前几周或几个月识别资产异常。可以预测故障发生的时间，并基于此调整维护优先级，并提供诸如补救行动的规范性建议。</p>
        <p>电力、油气、化工等行业的领导者们相信 AVEVA Predictive Analytics 预测分析可以最大限度地提高资产可靠性并预防计划外停机。</p>
        <div class="img-one">
            <img src="@/assets/PC/about/img13.png" alt="">
        </div>
        <div class="title3">AVEVA Asset Strategy Optimization 策略优化</div>
        <p>AVEVA Asset Strategy Optimization 策略优化利用以可靠性为中心的维修（RCM）理念使您能够制定基于风险的维修策略，使设备失效的风险与企业业务目标联系起来，避免过维护及欠维护，以实现最佳资产绩效。通过 AVEVA Asset Strategy Optimization 策略优化可以帮助您全面了解关键资产、故障行为和缓解措施。模拟多种维护策略并评估其对业务目标的影响，提高资产可用性、HSE 合规性、生产力与盈利能力。</p>
        <div class="img-half">
            <img src="@/assets/PC/about/img14.png" alt="">
        </div>
        <p>AVEVA Asset Strategy Optimization 还提供了一套资产策略知识库在完整的资产数据基础上包含了 20 年的故障模式数据，从而确保了维修策略的快速部署。资产策略知识库中包含基于 RCM 的设备故障数据和预防性维护（PM）模板，覆盖了资产密集型行业中 100 种最常见的资产类型。</p>
        <div class="title3">AVEVA 价值链优化</div>
        <p>端到端价值链的数字化转型战略可解决各个功能领域的问题。</p>
        <div class="li"><span></span><div class="li-text"><b>一体化供应链管理（AVEVA USC，也叫 Spiral Suite）：</b>丰富的原油数据库，原油 & 原料建模与知识管理，降低原油采购成本; 计划、调度和网络优化：计划优化、调度排产以及考虑采购和分销物流网络的多厂、多周期计划优化。</div></div>
        <div class="li"><span></span><div class="li-text"><b>工艺实时优化（AVEVA Process Optimization, 也叫 ROMeo）：</b>基于严格机理的实时优化平台，在满足装置全部约束条件下，通过优化装置的操作条件，24 小时地最大化装置的经济效益。</div></div>
        <div class="li"><span></span><div class="li-text"><b>性能监测（AVEVA Process Optimization-Performance Monitoring System）：</b>自动监测设备性能，通过识别设备性能退化，避免事故；识别不良仪表。</div></div>
        <div class="li"><span></span><div class="li-text"><b>能效管理（AVEVA Process Optimization-Refinery & Manufacturing  Utilities System）：</b>在满足全部的约束条件下，在满足蒸汽/电力的需求基础上，最小化公用工程系统的运行成本。</div></div>
        <div class="li"><span></span><div class="li-text"><b>绿氢管理（AVEVA Process Optimization-Renewables & Green Utilities System）：</b>支持绿氢和氢气管理。</div></div>
        <div class="li"><span></span><div class="li-text"><b>生产管理（AVEVA Production Accounting）：</b>通过数据整定，提供了精确的物料平衡的计算平台，减少核算损失，减少库存以及降低氢气和蒸汽消耗。</div></div>
        <div class="title3">AVEVA PI System 解决方案</div>
        <p>AVEVA PI System 是⼯业环境中管理实时，时间序列数据的⻩⾦标准，是一款从工业边缘到云端的数据管理解决方案，专为采集、存储、分析和共享实时运营数据而设计。能够整合来自传感器、工业物联网设备及远程资产的数据，确保企业在分布式环境中实现高效的数据管理与分析。</p>
        <p>PI System 提供唯一数据源，消除数据孤岛，使运营数据具备情境信息，便于实时监控、预测性维护、质量管理及流程优化。系统可无缝对接企业应用、分析工具及 AI/ML 平台，实现数据驱动的智能决策。</p>
        <p>通过云端扩展，PI System 让企业能够安全地共享运营数据，提高业务透明度和协作效率，助力数字化转型，提升运营可持续性与竞争力。</p>
        <div class="img-one">
            <img src="@/assets/PC/about/img15.png" alt="">
        </div>
        <p>PI System 这种无缝集成的边缘-云端混合架构，使用户能够从任何位置采集运营环境中的关键数据，并将之提供给任何位置上的工程师、分析师、数据科学家、开发人员和决策者。本地部署的 PI System 为用户提供 24/7 全天候的实时信息，以支持其日常运营。部署在工业边缘的 PI System 将数据采集扩展到远程站点和带有传感器的资产和设备。经验证的利益相关方可从任何地点通过云数据管理服务 Connect Data Service 访问 AVEVA PI System 的运营数据。利用云服务的可扩展性和成本效益，让远程用户、高级分析工具、业务合作伙伴甚至客户能够轻松获取数据。它们一起构成了 AVEVA PI System，可以确保大型分布式企业中数据的完整性和可用性。</p>
        <div class="title2">7. 企业文化与责任</div>
        <div class="title3">企业目的</div>
        <p>激发工业创造力</p>
        <div class="title3">企业使命</div>
        <p>用可靠的信息和洞察力把人们联系起来</p>
        <div class="title3">企业愿景</div>
        <p>推动业界高质量地使用全球资源</p>
        <div class="title3">ESG 支柱</div>
        <p>技术手印 运营足迹 包容性文化</p>
        <div class="title3">价值观</div>
        <p>影响：推动积极的成果，为世界开创可持续的未来</p>
        <p>愿望：志存高远，超越预期</p>
        <p>好奇：不断提出问题并通过实验找到强大而有意义的解决方案</p>
        <p>信任：以人为本，在包容和尊重的基础上增进人际关系</p>
        <div class="title3">可持续发展进程</div>
        <div class="li"><span></span>AVEVA 剑维软件是行业首批获得科学减碳倡议组织（Science Based Targets initiative, SBTi）净零排放目标认证的企业。</div>
        <div class="li"><span></span>2023 年，AVEVA 剑维软件制定了一项新的绿色标识计划，在该计划最初六个月内支持 90+ 家客户的绿色能源转型技术项目的部署。</div>
        <div class="li"><span></span>每年举行内部创新和合作伙伴创新大赛。</div>
        <div class="li"><span></span>2023 年，AVEVA 剑维软件实现了 2025 年 ESG 15 项目标中的 4 项。</div>
        <div class="li"><span></span>AVEVA 是《金融时报》2023 年气候领导者重点名单的成员。</div>
        <div class="li"><span></span>2023 年，AVEVA 参与 CDP 气候变化问卷披露，并在一般气候变化问卷中被评为管理级别（B）。 </div>
        <div class="li"><span></span>2023 年，AVEVA 在第三次 EcoVadis 评估中获得了金牌评级。</div>
        <div class="li"><span></span>2022 年 7 月，AVEVA 首次提交了 S&P 企业可持续发展评估的回应。AVEVA 获得了 46/100 的 ESG 评分。 </div>
        <div class="li"><span></span>2022 年，AVEVA 加入绿色软件基金会（GSF）。 </div>
        <div class="li"><span></span>2021 年，AVEVA 加入联合国全球契约（UNGC）成为参与成员。</div>
        <div class="li"><span></span>2021 年，AVEVA 承诺加入 1.5°C 商业雄心运动。敦促公司设定与《巴黎协定》下最高雄心水平一致的减排目标。 </div>
        <div class="li"><span></span>AVEVA 成为 Aldersgate Group 的成员。也是企业领导者集团（CLG）的成员。 </div>
        <div class="li"><span></span>AVEVA 是世界经济论坛自然与气候中心平台的成员，并参与 2030Vision 计划。</div>
        <div class="li"><span></span>AVEVA 是 First Movers Coalition 的成员，AVEVA 承诺到 2030 年将至少 5% 或更多的传统航空燃料替换为可持续航空燃料（SAF） 。</div>
        <div class="li"><span></span>AVEVA 拥有 MSCI AA 评级。MSCI ESG 研究是独立的 ESG 数据提供商。</div>
        <div class="title3">公益活动</div>
        <p>AVEVA 剑维软件以员工参与为导向的“公益行动”计划，特别为员工提供带薪休假——“改变世界的三天”，让每位员工都能暂时放下手头工作，投身公益事业，从环保植树到教育助学，从社区服务到文化传承，全方位践行社会责任，携手共创一个更加和谐美好的世界。 </p>
        <div class="img-one">
            <img src="@/assets/PC/about/img16.png" alt="">
        </div>
        <div class="title2">8. 企业荣誉</div>
        <p>2025 年，泰尔文特控制系统（中国）有限公司（隶属于 AVEVA Group）获评北京市外资研发创新中心</p>
        <p>2025 年 1 月 22 日 ，AVEVA 剑维软件在《IDC MarketScape：2024 - 2025 年全球制造执行系统供应商评估》中被评为领导者类别</p>
        <p>2024 年，AVEVA 剑维软件荣膺 2024 年度智象奖最具营销力半导体数字化平台奖</p>
        <p>2024 年，AVEVA InTouch HMI 荣膺中国工控自动化领域 SCADA 与控制系统类 2024 年度最佳产品奖</p>
        <p>2023 年 6 月，AVEVA 剑维软件荣膺 IDC MarketScape 全球流程制造执行系统供应商领导者称号</p>
        <p>2023 年，AVEVA™ System Platform 系统平台荣膺第二十二届 CAIMRS 自动化及数字化年度评选自动化创新奖</p>
        <p>2023 年，AVEVA™ System Platform 系统平台 2023 版本荣膺中国工控自动化领域 SCADA 和过程控制系统类 2023 年度最佳产品奖</p>
        <p>2023 年，AVEVA 剑维软件荣膺 2023 年度智象奖电子半导体工业软件平台优秀提供商</p>
        <p>2023 年，AVEVA 系统平台 2023 版本荣膺智能制造行业荣格技术创新奖</p>
        <p>2022 年 9 月，AVEVA 剑维软件入选 Fast Company 2022 年度全球最具创新力公司</p>
        <p>2022 年，AVEVA 剑维软件荣膺 2022 年度“金钥匙 —— 面向 SDG 的中国行动”荣誉奖</p>
        <p>2021 年 8 月 3 日，AVEVA 剑维软件荣膺全球最佳工业软件解决方案供应商大奖</p>
        <p>2021 年 5 月 24 日，AVEVA 剑维软件荣膺 2021 年度 Gartner 制造执行系统魔力象限领导者</p>
        <p>2021 年 4 月 7 日，AVEVA 剑维软件为全球食品饮料行业研发的制造执行系统荣获弗若斯特沙利文 2020 年度产品领导力大奖</p>
        <p>2020 年，AVEVA 剑维软件荣获烃加工奖的“最佳健康、安全或环境贡献奖”和“最佳仪器技术奖”双奖 </p>
        <p>2020 年 6 月 29 日，AVEVA 剑维软件在 Verdantix 发布的 2020 年资产绩效管理（APM）解决方案绿色象限报告中被评为市场领导者 </p>
        <p>2019 年，AVEVA 剑维软件荣膺 2019 年度 Gartner 制造执行系统魔力象限领导者</p>
        <p>2014 年，AVEVA 剑维软件荣获“英国最受尊敬的软件和计算机服务公司”大奖</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'About',
  data() {
    return {
    }
  }
}
</script>

<style scoped lang="scss">
$mobil_base: 750;
@function vw($true) {
  @return ($true / $mobil_base) * 100vw;
}
.container {
    max-width: 1200px; margin: 0 auto;width: 100%; padding: 40px 0;
}
.logo{
    display: flex;
    justify-content: flex-end;
    img{
        width: 200px;
    }
}
.title1 {
    font-size: 32px;
    font-weight: bold;
    color: #7114B5;
    margin: 30px 0 50px 0;
}
.title2 {
    font-size: 24px;
    font-weight: bold;
    color: #7114B5;
    margin: 30px 0;
}
.title3 {
    font-size: 20px;
    font-weight: bold;
    color: #7114B5;
    margin: 20px 0;
}
p {
    font-size: 16px;
    color: #363d42;
    line-height: 30px;
    margin-bottom: 20px;
}
p span{
    color: #7114B5;
    font-weight: bold;
    font-size: 16px;
}
p b{font-size: 16px;}
.tip{color: rgba($color: #000000, $alpha: 0.5);}
.introduction span {
    font-weight: bold;
    color: #7114B5;
}
.intro-item, 
.intro-item b{
    font-size: 16px;
    color: #363d42;
    line-height: 30px;
}
.li {
    display: flex;
    align-items: flex-start;
    font-size: 16px;
    color: #363d42;
    line-height: 1.5;
    margin-bottom: 10px;
}
.li span {
    width: 6px;
    height: 6px;
    background: #000;
    border-radius: 50%;
    display: inline-block;
    margin-right: 10px;
    margin-top: 10px;
    flex-shrink: 0;
}
.li b,
.li .li-text{
    font-size: 16px;
}
.table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
}
.table-header, .table-body {
    display: flex;
}
.table-header{
    background-color: #7114B5;
    color: #fff;
}
.table-body{
    background-color: #fff;
    color: #000;
    border-collapse: collapse;
}
.table-header div,
.table-body div {
    flex: 1;
    font-size: 16px;
    line-height: 1.5;
    padding: 10px;
    border-collapse: collapse;
    border: 1px solid #999;
}
.table-header div{
    font-size: 18px;
    font-weight: bold;
}
.table-body div{
    border-top: none;
}
.table-body div + div{
    border-left: none;
}
.table-header div{
    border: 1px solid #7114B5;
}
.table-header div + div{
    border-left: 1px solid #fff;
}


.img-half{
    margin: 10px 0;
    display: flex;
    justify-content: center;
    img{
        width: 50%;
        height: auto;
        margin: 0 auto;
        object-fit: cover;
    }
}
.img-one{
    margin: 10px 0;
    img{
        width: 100%;
        height: auto;
        object-fit: cover;
    }
}
.img-two{
    display: flex;
    justify-content: space-between;
    margin: 10px 0;
    img {
        width: calc(100% / 2 - 20px);
        object-fit: cover;
    }
}
.img-three {
    display: flex;
    justify-content: space-between;
    margin: 10px 0;
    img {
        width: calc(100% / 3 - 20px);
        object-fit: cover;
    }
}

@media screen and (max-width: 768px) {
.container {
    max-width: 100%;
    padding: 20px 20px;
}
.logo{
    img{
        width: 100px;
    }
}
.title1 {
    font-size: 24px;
    margin: 30px 0 30px 0;
}
.title2 {
    font-size: 20px;
    margin: 20px 0;
}
.title3 {
    font-size: 18px;
    margin: 15px 0;
}
p {
    font-size: 14px;
    line-height: 1.6;
    margin-bottom: 10px;
}
p span,
p b{font-size: 14px;}
.intro-item ,
.intro-item b{
    font-size: 14px;
    line-height: 1.6;
}
.li {
    font-size: 14px;
    line-height: 1.6;
    margin-bottom: 10px;
}
.li span {
    width: 5px;
    height: 5px;
    margin-right: 10px;
    margin-top: 10px;
}
.li b,
.li .li-text{
    font-size: 14px;
}
.table {
    width: 100%;
    margin-bottom: 20px;
}
.table-header div,
.table-body div {
    font-size: 14px;
    line-height: 1.6;
    padding: 10px;
}
.table-header div{
    font-size: 16px;
}

.img-half{
    margin: 10px 0;
    img{
        width: 50%;
    }
}
.img-one{
    margin: 10px 0;
}
.img-two{
    margin: 10px 0;
    img {
        width: calc(100% / 2 - 5px);
    }
}
.img-three {
    margin: 10px 0;
    img {
        width: calc(100% / 3 - 5px);
    }
}
}
</style>
